import { useState } from "react";
import { useParams } from "react-router-dom";
import { FaTrash } from "react-icons/fa";
import { FaCirclePlus } from "react-icons/fa6";
import { DataTableColumn } from "../../../../components/common/datatable/DataTableTypes";
import { DataTable } from "../../../../components/common/datatable/DataTable";
import { useDeleteAssociationFeeByIdMutation, useSearchAssociationFeeApiQuery } from "../associationApi";
import { dateTimeOffset } from "../../../../helpers/utils/Utils";
import ModalButton from "../../../../components/common/form/ModalButton";
import AssociationFeeModal from "./Modal/AssociationFeeModal";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";
import { useGetEnumsQuery } from "../../../../app/globalApi";
import { formatAsCurrency } from "../../../../helpers/utils/TextUtils";


const AssociatinonFee = () => {

    let { associationId } = useParams();
    const [associationFeeId, setAssociationFeeId] = useState("");
    const [showAssociationFeeUpdate, setShowAssociationFeeUpdate] = useState(false);
    const iconButtonStyle = "cursor-pointer text-surface-2 text-md ";
    const { data: feeTypeEnums } = useGetEnumsQuery("");

    const { data: associationsData } = useSearchAssociationFeeApiQuery({ "associationId": associationId })
    const [deleteAssociationFee, { isLoading }] = useDeleteAssociationFeeByIdMutation();

    const handleDelete = async (feeId: string) => {
        if (feeId) {
            await deleteAssociationFee(feeId).unwrap();
        }
    };



    const columns: DataTableColumn[] = [
        {
            label: "Type", accessor: "feeType", visibility: { hasShowSetting: false },
            cell: (props: any) => {
                const feeTypeLabel = feeTypeEnums?.["FeeType"]?.find(
                    (curEnum: any) => curEnum.constant === props.value
                )?.value || "Unknown Type";

                return (
                    <span
                        className="column-link active cursor"
                        style={{ color: "#007BFF", cursor: "pointer" }}
                        onClick={(e) => {
                            e.stopPropagation(); 
                            setAssociationFeeId(props.row.original.id);
                            setShowAssociationFeeUpdate(true);
                        }}
                    >
                        {feeTypeLabel}
                    </span>
                );
            }

        },

        {
            label: "Amount", accessor: "feeAmount", visibility: { hasShowSetting: false },
            cell: (props: any) => {
                return <span>{formatAsCurrency(props.value)}</span>;
            }
        },
        {
            label: "Frequency", accessor: "frequency", visibility: { hasShowSetting: false },
        },
        {
            label: "Period", accessor: "assessmentPeriodStart", visibility: { hasShowSetting: false },
            cell: (props: any) => {
                return <>
                    <span
                        className={props.value ? "formatted_date" : "formatted_date align_empty_dash"}>{props.row.original.assessmentPeriodStart ? dateTimeOffset(props.row.original.assessmentPeriodStart, "MM/DD") : ''}{props.value ? " - " : "-"} </span>
                    <span
                        className="formatted_date">{props.row.original.assessmentPeriodEnd ? dateTimeOffset(props.row.original.assessmentPeriodEnd, "MM/DD") : ''}</span>
                </>
            },
        },
        {

            label: "Note", accessor: "note", visibility: { hasShowSetting: false },
            cell: (props: any) => {
                return <>
                    {props.value ? <div className="delete_btn_center_align"><i title={props.value}
                        className="fa fa-sticky-note" />
                    </div> : ''}
                </>
            }
        },
        {
            label: "Action", accessor: " ",
            canSort: false,
            cell: (props: any) => {
                return <>
                    <div className="ml-3">
                        <ModalButton
                            triggerButton={<FaTrash className={iconButtonStyle}
                                title={"Delete Note"} />}
                            modal={
                                <ConfirmationModal
                                    show={true}
                                    setShow={() => {
                                    }}
                                    title={"Delete Association Fee"}
                                    bodyMessage={"Are you sure you want to delete this Association Fee?"}
                                    onSubmit={() => handleDelete(props?.row?.original?.id)}
                                    isLoading={isLoading}
                                />
                            }
                        />
                    </div>
                </>
            }
        }
    ]

    return (

        <div className="bg-text-1 shadow-[0_3px_10px_#0003] text-sm mt-3 rounded-md">
            <div className="flex justify-between items-center border-b border-[rgba(0,0,0,0.1)] p-2">
                <h5 className="font-semibold text-surface-0">Association Fee ({associationsData?.data?.length})</h5>
                <ModalButton
                    triggerButton={
                        <FaCirclePlus
                            title={"Add Note"}
                            className={`${iconButtonStyle} !text-highlight-0`} />
                    }
                    modal={
                        <AssociationFeeModal
                            show={true}
                            setShow={() => {
                            }}
                            associationId={associationId}
                        />
                    }
                />

            </div>

            <div className="p-3">
                <div className="w-full bg-text-0 border-2 border-[rgba(0,0,0,0.1)]">
                    <DataTable
                        columns={columns}
                        actions={{
                            fetchAction: useSearchAssociationFeeApiQuery,
                        }}
                        defaultSortOptions={{
                            accessor: "creationDate",
                            direction: "asc",
                        }}
                        defaultFilter={{
                            associationId: associationId,
                            pageNumber: 0,
                            pageSize: 6
                        }}
                        appendFilterToUrl={false}
                        renderOptions={{ skipUserSettingRender: true, skipPaginationRender: false }}
                        basePermission={"AUTOHOA"}
                        classname="bg-text-0 text-surface-0 border-b border-surface-5 "
                    />
                </div>
            </div>

            {showAssociationFeeUpdate && (
                <AssociationFeeModal
                    show={showAssociationFeeUpdate}
                    setShow={setShowAssociationFeeUpdate}
                    associationFeeId={associationFeeId}
                    associationId={associationId}
                />
            )}


        </div>
    );
}
export default AssociatinonFee;